import { Box, Text } from '@rbilabs/universal-components';

export const ReloadWrapper = Box.withConfig({
  marginX: 0,
  marginY: '$4',
});

export const InstructionText = Text.withConfig({
  marginTop: '$3',
  marginBottom: '$2.5',
  fontSize: 'lg',
  width: '80%',
  variant: 'headerTwo',
});

export const LoadContainer = Box.withConfig({
  marginTop: '$6',
});

export const BoldText = Text.withConfig({
  fontWeight: 'bold',
});

export const InstructionsContainer = Box.withConfig({
  width: '90%',
  borderBottomWidth: '1',
  borderBottomColor: 'blackOpacity.10',
  marginX: '5%',
});
